import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNotification } from "../../../../context/NotificationContext";
import {
    handleAudioEditorError,
    handleAudioEditorWarning,
    handleAudioEditorInfo,
    handleAudioEditorSuccess,
} from "../utils";

export const useAudioEditorNotifications = () => {
    const { showNotification } = useNotification();
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const notifyError = useCallback(
        (error: unknown, context: string = t("unexpectedError")) => {
            handleAudioEditorError(error, context, showNotification);
        },
        [showNotification],
    );

    const notifyWarning = useCallback(
        (message: string) => {
            handleAudioEditorWarning(message, showNotification);
        },
        [showNotification],
    );

    const notifyInfo = useCallback(
        (message: string) => {
            handleAudioEditorInfo(message, showNotification);
        },
        [showNotification],
    );

    const notifySuccess = useCallback(
        (message: string) => {
            handleAudioEditorSuccess(message, showNotification);
        },
        [showNotification],
    );

    return {
        notifyError,
        notifyWarning,
        notifyInfo,
        notifySuccess,
    };
};

export default useAudioEditorNotifications;
